import { ActionTypes } from './index'
import { showErrorNotification } from 'Shared/helpers'

export const toggleCategorySimGolf = (id) => (dispatch, getState) => {
  const filter = getState().filters.leagueName
  if (filter !== '') {
    dispatch({ type: ActionTypes.TOGGLE_CATEGORY_WHILE_FILTERING, id })
    return
  }

  const path = getState().misc.fetchCategoryLeaguesURL
  const filters = getState().filters
  const isCategoryOpen = getState().categories[id].opened

  if (isCategoryOpen) {
    dispatch({ type: ActionTypes.TOGGLE_CATEGORY, id })
    return
  }

  const category = getState().categories[id]

  if (category.leaguesCount === 0) {
    dispatch({ type: ActionTypes.TOGGLE_CATEGORY, id })
    return
  }

  const leaguesAlreadyLoaded = category.leagues.length > 0 &&
    category.leagues.every(leagueId => getState().leagues[leagueId] !== undefined)

  if (leaguesAlreadyLoaded) {
    dispatch({ type: ActionTypes.TOGGLE_CATEGORY, id })
    return
  }

  dispatch({
    type: ActionTypes.SET_CATEGORY_LOADING_DATA,
    id: id,
    loadingData: true,
  })

  $.ajax({
    method: 'GET',
    url: path,
    data: {
      format: 'json',
      categoryId: id,
      page: 0,
      filters: filters,
    },
  })
  .done((response) => {
    dispatch({
      type: ActionTypes.SET_CATEGORY_LOADING_DATA,
      id: id,
      loadingData: false,
    })

    dispatch({
      type: ActionTypes.APPEND_LEAGUES,
      leagues: response.data,
    })

    if (response.categoryCounts !== null) {
      dispatch({
        type: ActionTypes.SET_CATEGORY_LEAGUE_COUNTS,
        categoryCounts: response.categoryCounts,
      })
    }

    dispatch({
      type: ActionTypes.TOGGLE_CATEGORY,
      id,
    })
  })
  .fail(() => {
    dispatch({
      type: ActionTypes.SET_CATEGORY_LOADING_DATA,
      id: id,
      loadingData: false,
    })
    showErrorNotification('Error while retreiving the category leagues!')
  })
}

export const toggleAdvancedFiltersSimGolf = (value) => (dispatch, getState) => {
  dispatch({
    type: ActionTypes.CHANGE_FILTER,
    filter: 'advancedFiltersOn',
    value,
  })

  const url = getState().misc.updateUserSettingsURL
  if (url) {
    $.ajax({
      method: 'POST',
      url,
      data: {
        name: 'customer_center',
        update_hash: { advancedFiltersOn: value },
      },
    })
  }
}
